// need to confirm with PM and designer

import { siteExclusionViewLists } from '../configs/tools/shared-library/site-exclusion-lists-account-level-view-lists';
import { siteExclusionListCreate } from '../configs/tools/shared-library/site-exclusion-lists-customer-level-create-lists';

export const websiteExclusion = {
  id: 'site-exlusion',
  name: _TL_('Website exclusion'),
  description: _TL_('Keep ads from showing on specific websites using account level website exclusion lists.'),
  children: [
    siteExclusionViewLists,
    siteExclusionListCreate,
  ],
};
